// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"229686cb","390":"c33b79f3","448":"9c47daf2","605":"975a1b04","674":"42093088","691":"2ba5b160","760":"b1526264"}[chunkId] + ".chunk.css";
};